import { useContext } from 'react';
import { ctxUser } from '@/contexts/UserContext';
import { usePreferencesState } from '@/hooks/usePreferencesState';

export function useUserPreferencesState<TStored, TValue = TStored>(
  preferencesKey: string,
  defaultValue: TValue,
  normalize?: (value: TStored) => TValue
) {
  const userCtx = useContext(ctxUser);
  const key = userCtx?.user
    ? `${preferencesKey}::${userCtx.user.isTokenUser ? '_token_' : userCtx.user.name}`
    : preferencesKey;
  return usePreferencesState(key, defaultValue, normalize);
}
